import VueSocketIO from 'vue-3-socket.io'
import SocketIO from 'socket.io-client'

const socketHost = process.env.VUE_APP_SOCKET_HOST
const socketPath = process.env.VUE_APP_SOCKET_PATH

console.log('HOST:', socketHost)
console.log('PATH:', socketPath)

const wsocket = new VueSocketIO({
    debug: true,
    connection: SocketIO(socketHost, {
        path: socketPath,
        //transports: ['websocket', 'polling']
    })
});

export default wsocket